<div class="container-fluid maap-root-container">
    <app-header *ngIf="headerEnabled"
           (deIdChange)="updateDeIdMode($event)" 
           [deId]="deId"
           [dissableDeIdSwitch]="dissableDeIdSwitch">
    </app-header>
    <app-sidebar [deId]="deId"
                 [dissableDeIdSwitch]="dissableDeIdSwitch"
                 (deIdChange)="updateDeIdMode($event)">
    </app-sidebar>
    <div style="margin-top: 60px; margin-left: 80px;">
    <header class="standalone-page-header px-5 pt-4">
        <h1 class="standalone-page-title">Peer Analytics</h1>
    </header>
    <div class="row">
        <div class="col-md-12">
            <!-- <div  class="float-right row maap-right-controls">
                <div  class="col-md-6 mt-2"> Date Range: 8/14/2019 through 9/13/2019 </div>
                <div  class="col-md-6"><button  type="submit"
                        class="btn btn-lg btn-light">Filter</button><span
                        class="d-inline-block mx-2">Search:</span><input  type="text"
                        id="formGroupExampleInput2" placeholder="" class="form-control d-inline-block"
                        style="width: 150px;"></div>
            </div> -->
        </div>
        <div class="col-md-12 mb-2">
            <!-- <a routerLink="/visualization/p2premoval" class="p2p-maap-graph-icon">
                <img src="/assets/images/icon_charts2.png" alt="">
            </a> -->
            <!-- <p-selectButton  class="p2p-days-selection" [options]="days"></p-selectButton> -->
        </div>
        <div class="col-md-12 px-5">
            <app-data-filter-pills [filterValues]="filterValues" (filterVal)="removeFilter($event)" (filterInputs)="openFilterModuleAfterMore($event)"></app-data-filter-pills>
        </div>
        <div class="col-md-12 px-5">

            <app-analytics-table #table [adminId]="adminId" [headerEnabled]="headerEnabled" [locId]="locId" [chartFilter]="chartFilter" (filterValue)="updatedFilterValue($event)"
                transactionType="All" (clearFilterPills)="clearAllFilterPills($event)"></app-analytics-table>

        </div>
    </div>
    </div>

</div>
